// extracted by mini-css-extract-plugin
export var actions = "_u1-4";
export var item = "_u1-1";
export var price = "_u1-3";
export var quantity = "_u1-2";
export var table = "_u1-0";